if ("serviceWorker" in navigator) {
  window.addEventListener("load", function () {
    var basePath = process.env.BASE_URL || "./";
    navigator.serviceWorker.register(basePath + "service-worker.js").catch(function (error) {
      // Registration failure must not interrupt the dashboard or authentication flow.
      console.warn("Service worker registration failed:", error);
    });
  });
}
